import React from 'react'
import Image from '@boltui/image'

import * as Styled from '../../Footer.styles'

const imgPath = '//www.argos.co.uk/cdn/argos-style/v1.1.4/assets/img'

const SocialAppFooter = () => (
  <Styled.SocialApp>
    <div className='container container--row'>
      <div className='row md-row xs-12--negative'>
        <div className='md-6'>
          <Styled.SocialAppTitle>Be first to know the latest deals</Styled.SocialAppTitle>
          <Styled.SocialAppLink
            data-test='footer-social-logo-youtube'
            href='https://www.youtube.com/user/argoscouk'
            target='_blank'>
            <Image
              alt='Argos YouTube channel'
              src={`${imgPath}/logo-youtube.svg`}
              qlt={80}
              lazy
              width={21}
              height={24}
            />
          </Styled.SocialAppLink>
          <Styled.SocialAppLink
            data-test='footer-social-logo-facebook'
            href='https://www.facebook.com/argos'
            target='_blank'>
            <Image
              alt='Argos Facebook page'
              src={`${imgPath}/logo-facebook.svg`}
              qlt={80}
              lazy
              width={12}
              height={25}
            />
          </Styled.SocialAppLink>
          <Styled.SocialAppLink
            data-test='footer-social-logo-twitter'
            href='https://twitter.com/Argos_online'
            target='_blank'>
            <Image alt='Argos Twitter feed' src={`${imgPath}/logo-twitter.svg`} qlt={80} lazy width={24} height={21} />
          </Styled.SocialAppLink>
        </div>

        <div className='md-6 xs-row'>
          <Styled.SocialAppTitle>Download our app</Styled.SocialAppTitle>
          <Styled.SocialAppLinkBottom
            apple
            className='xs-6'
            data-test='footer-app-apple-mobile'
            href='https://itunes.apple.com/gb/app/argos/id370371087?mt=8'
            target='_blank'>
            <Image
              alt='Apple download app image'
              src={`https://media.4rgos.it/i/Argos/app-apple-prompt`}
              qlt={80}
              width={134}
              height={38}
              lazy
            />
          </Styled.SocialAppLinkBottom>
          <Styled.SocialAppLinkBottom
            google
            className='xs-6'
            data-test='footer-app-googleplay'
            href='https://play.google.com/store/apps/details?id=com.homeretailgroup.argos.android&hl=en'
            target='_blank'>
            <Image
              alt='Google play download app image'
              src={`https://media.4rgos.it/i/Argos/app-google-prompt`}
              qlt={80}
              width={134}
              height={38}
              lazy
            />
          </Styled.SocialAppLinkBottom>
        </div>
      </div>
    </div>
  </Styled.SocialApp>
)

export default SocialAppFooter
